import { httpClient } from '@/utils/http-client';
class TranscriptService {
    httpClient;
    constructor() {
        this.httpClient = httpClient;
    }
    async searchVector(videoId, keyword) {
        const payload = {
            videoId: videoId,
            keyword: keyword
        };
        const response = await this.httpClient.post('/search', payload);
        return response.data;
    }
}
export default TranscriptService;
